module.exports = __webpack_public_path__ + "assets/like-active.9c56581b.svg";